<template>
<div>
    <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'"> {{$t('form.client-address.votre_adresse')}} </h1>
    <sav-fold-card v-model="open" class="mt-4" :close-button="false" :can-open="canOpen"  :id="$options.name">
        <template v-slot:close>
            <template v-if="selected">
                <div class="font-bold">{{selected.fullAddress}}</div>
            </template>
        </template>
        <template v-slot:open>
            <sav-spinner class="mt-4" v-if="loading" :size="10" />
            <template v-if="!loading">
                <template v-if="!manualAddress">
                    <template v-for="(address, index) in addresses">
                        <div @click="end(address)" :test-id="'my-addresses-' + index" :key="index" class="p-6 my-3 text-gray-900 duration-200 border border-gray-200 cursor-pointer my-rounded hover:bg-gray-100">
                            <small class="block font-bold">{{address.prenom + ' ' + address.nom}}</small>
                            <div class="text-gray-600"> {{address.fullAddress}} </div>
                        </div>
                    </template>
                    <button @click="manualAddress = true" class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-blue-600 border-blue-700 hover:bg-blue-700 rounded-xl">
                        <i class="mr-2 fas fa-search"></i>{{$t('form.client-address.recherche_manuelle')}}
                    </button>
                </template>
                <template v-if="manualAddress">
                    <template v-if="addresses.length > 0">
                        <button @click="manualAddress = false" class="px-5 py-2.5 text-sm font-base duration-100 duration-200 bg-gray-200 border-gray-300 hover:bg-gray-300 rounded-xl">
                            <i class="mr-1 fas fa-home"></i> {{$t('form.client-address.mes_adresses')}}
                        </button>
                        <hr class="my-3">
                    </template>
                    <sav-map-input :map="false" class="mt-2" @input="end" />
                </template>
            </template>
        </template>
    </sav-fold-card>
</div>
</template>



<script>
import apiService from '@/services/api.service'

import AddressTool from '@/tools/AddressTool'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'client-address',
    extends: FormCardExtension,

    data() {
        return {
            manualAddress: false,
            addresses: null,
            selected: null,
        }
    },
    methods: {
        init() {
            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.getNextBlock()
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            this.getUserData()
        },

        async end(callbackData) {
            if (this.manualAddress) {
                let newAddress = await this.saveAddressInAccount(callbackData)
                callbackData.id = newAddress.posts.post
                callbackData.address1 = callbackData.adresse1
                callbackData.address2 = callbackData.adresse2
                callbackData.fullAddress = callbackData.adresse1 + ', ' +callbackData.cp + ' ' + callbackData.ville
            }
            this.$nextTick(() => {
                this.$formTool.addFormData(this.$options.name, callbackData)
                this.nextBlock = this.getNextBlock()
                if (this.selected) {
                    this.$emit('update', this.$options.name)
                }
                this.selected = JSON.parse(JSON.stringify(callbackData))
            })
        },

        getNextBlock() {
            return this.$formTool.blockData(this.$options.name).next.setCase
        },

        async saveAddressInAccount(data) {
            var user = await apiService.getUser()
            let response = await apiService.post('add_address', {
                id_conso: user.id,
                nom: data.nom,
                prenom: data.prenom,
                adresse1: data.adresse1,
                adresse2: data.adresse2,
                cp: data.cp,
                ville: data.ville,
                longitude: data.longitude,
                latitude: data.latitude
            })
            return response.data
        },

        resetAddress() {
            this.manualAddress = false
            this.selected = null
        },

        async getUserData() {
            this.loading = true
            var user = await apiService.getUser()
            if (user.list_address) {
                var newAddressFormat = AddressTool.convertAddressesList(user.list_address)
                // Tricks life cycle
                setTimeout(() => {
                    this.addresses = newAddressFormat
                    if (this.addresses.length <= 0) {
                        this.manualAddress = true
                    }
                }, 400)
            }
            setTimeout(() => {
                this.loading = false
            }, 400)
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/Components/ClientAddressCard.vue